import React from "react";
import "./boq.css";
import BOQHeader from "./boqHeader";
import BOQFooter from "./boqFooter";
import BOQInfo from "./boqInfo";

export default function BOQ() {

  return (
    <div className="boq-container">
      <BOQHeader></BOQHeader>
      <BOQInfo></BOQInfo>
      <BOQFooter></BOQFooter>
    </div>
  );
}
